import { EditVehicleValues } from "./editVehicleForm.utils";

export type Option = string | [string, string];

export const valueOf = (option: Option) => (Array.isArray(option) ? option[0] : option);
export const labelOf = (option: Option) => (Array.isArray(option) ? option[1] : option);

export const fieldId = (field: keyof EditVehicleValues) => `edit-vehicle-${field}`;
